import { SearchGroupKind } from '../../api/search/searchApiTypes';
import {
    makeAssetDetailsUrl,
    makeCustomerAccountDetailUrl,
    makeProductDetailsUrl,
    makeRentalBookingDetailsUrl,
} from '../../routes';

/**
 * Where a search hit opens — the existing detail page of each kind, through
 * the same URL helpers the lists use (bookings by order id, as the bookings
 * list and the invoice list link them).
 */
export const searchResultPath = (kind: SearchGroupKind, id: string): string => {
    switch (kind) {
        case 'bookings':
            return makeRentalBookingDetailsUrl(id);
        case 'customers':
            return makeCustomerAccountDetailUrl(id);
        case 'objects':
            return makeAssetDetailsUrl(id);
        case 'products':
            return makeProductDetailsUrl(id);
    }
};
